export default "__VITE_PUBLIC_ASSET__9be1cde9__"